import { render, staticRenderFns } from "./TicketTab.vue?vue&type=template&id=54d7a71a&scoped=true&"
import script from "./TicketTab.vue?vue&type=script&lang=js&"
export * from "./TicketTab.vue?vue&type=script&lang=js&"
import style0 from "./TicketTab.vue?vue&type=style&index=0&id=54d7a71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d7a71a",
  null
  
)

export default component.exports